<template>
  <span class="status-tag" :class="statusBadgeStyle">
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: 'RequirementStatusBadge',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    statusBadgeStyle() {
      if(this.status === 'Not Accepted') {
        return 'not-accepted';
      }
      if(this.status === 'No Tasks') {
        return 'no-tasks';
      }
      if(this.status === 'Not Started') {
        return 'not-started';
      }
      if(this.status === 'In Progress') {
        return 'in-progress';
      }
      if(this.status === 'Closed') {
        return 'closed';
      }
    }
  }
}
</script>
<style scoped>
span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.status-tag.no-tasks {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}
.status-tag.not-started {
  background-color: #F6F6FA;
  color: #2E2E38;
}
.status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}
.status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}
.status-tag.not-accepted {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}
</style>